import React from "react";
import "./style.scss";
import config from "../../config";
import ENV from "../../Constants/env";

const EnvironmentBlock = () => {
  if (process.env.REACT_APP_NODE_ENV === ENV.PRODUCTION) {
    return null;
  }

  return (
    <div className="EnvironmentBlock">
        <div className="App_environment">Environment: {config.env}</div>
    </div>
  );
};

export default EnvironmentBlock;
